import ease from 'easy-ease';

const myEase = (options, onStep, onComplete) => {
    let timeout = options.timeout || 0;
    let discreteSteps = options.discreteSteps || false;

    let doneIndices = [];

    options.onStep = (value) => {
        if(!!discreteSteps){
            let discreeteValue = Math.round(value);
            if(doneIndices.indexOf(discreeteValue) == -1){
                onStep(discreeteValue);
                doneIndices.push(discreeteValue);
            }
        }
        else{
            onStep(value);
        }
    }
    if(!!onComplete){
        options.onComplete = onComplete;
    }
    if(timeout > 0){
        setTimeout(function(){
            ease(options);
        },timeout);
    }
    else{
        ease(options);
    }
}
export default myEase;